import React from 'react';
export function StatsSection() {
  return <section className="py-14 bg-navy text-white" data-id="element-92">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-93">
        <div className="text-center mb-12" data-id="element-94">
          <h2 className="text-3xl md:text-4xl font-bold" data-id="element-95">
            Trusted by Local Businesses Like Yours
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 divide-y md:divide-y-0 md:divide-x divide-navy-light" data-id="element-96">
          <div className="text-center py-6 md:py-0" data-id="element-97">
            <div className="text-5xl font-extrabold text-orange mb-2" data-id="element-98">40+</div>
            <div className="text-lg font-medium text-gray-300" data-id="element-99">
              years serving Upstate NY
            </div>
          </div>

          <div className="text-center py-6 md:py-0" data-id="element-100">
            <div className="text-5xl font-extrabold text-orange mb-2" data-id="element-101">90%+</div>
            <div className="text-lg font-medium text-gray-300" data-id="element-102">
              local clients
            </div>
          </div>

          <div className="text-center py-6 md:py-0" data-id="element-103">
            <div className="text-5xl font-extrabold text-orange mb-2" data-id="element-104">30+</div>
            <div className="text-lg font-medium text-gray-300" data-id="element-105">
              communities served
            </div>
          </div>
        </div>
      </div>
    </section>;
}